import BigNumber from 'bignumber.js';

import { api } from 'modules/api';
import { getExtendedErrorText } from 'modules/common/utils/getExtendedErrorText';
import { queryFnNotifyWrapper } from 'modules/common/utils/queryFnNotifyWrapper';

import { getMainTokenUSDRatio } from '../methods/getMainTokenUSDRatio';

export const { useGetMainTokenUSDRatioQuery } = api.injectEndpoints({
  endpoints: build => ({
    getMainTokenUSDRatio: build.query<BigNumber | undefined, void>({
      queryFn: queryFnNotifyWrapper<void, void, BigNumber | undefined>(
        async () => {
          return { data: await getMainTokenUSDRatio() };
        },
        error => getExtendedErrorText(error, 'Failed to get USD ratio'),
      ),
      providesTags: [],
    }),
  }),
});
